/** external */
import React from "react";
import classNames from "classnames";
/** relative */
import classes from "./NoResponseComponent.scss";

const NoResponseComponent = props => {
  const { t } = props;

  const textClasses = classNames("text-subtitle-2", classes.text);
  return (
    <div className={classes.container}>
      <div className={textClasses}>
        {t("common:no_with_label", { label: t("common:response") })}
      </div>
    </div>
  );
};

export default NoResponseComponent;
